import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Quotes, ArrowRight } from '@phosphor-icons/react';

/**
 * Sprint C — DoctorQuestionCard
 * Single smart prompt the user could ask their doctor.
 * Source: /api/health/state.doctor_question (string | null).
 * Hidden when null (frontend never invents one).
 */
export const DoctorQuestionCard = ({ question }) => {
  const navigate = useNavigate();
  if (!question) return null;

  return (
    <section
      data-testid="doctor-question-card"
      className="bg-white border border-[#E5DFD0] rounded-2xl p-5"
    >
      <div className="flex items-center gap-2 mb-3">
        <Quotes size={14} weight="duotone" className="text-slate-400" aria-hidden />
        <h3 className="text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-500">
          Good question for your doctor
        </h3>
      </div>
      <p
        data-testid="doctor-question-text"
        className="font-serif italic text-[16px] sm:text-[17px] leading-[1.5] text-[#0E1C2E]"
      >
        “{question}”
      </p>
      <button
        type="button"
        onClick={() => navigate('/chat', { state: { seedQuery: question } })}
        data-testid="doctor-question-cta"
        className="mt-4 inline-flex items-center gap-1.5 text-[12.5px] font-medium text-[#235347] hover:text-[#1A3F36] group"
      >
        Talk this through with Kindra first
        <ArrowRight size={12} weight="bold" className="transition-transform group-hover:translate-x-0.5" />
      </button>
    </section>
  );
};

export default DoctorQuestionCard;
